<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
    <Header />
    <v-content class="mt-12">
      <router-view></router-view>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: {
    Header,
    Footer
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    }
  },
  data: () => ({
    user: null
  }),
  // mounted() {
  //   fb.auth().onAuthStateChanged(user => {
  //     if (user) {
  //       this.user = user;
  //     }
  //   });
  // },
  methods: {}
};
</script>

<style lang="scss">
:root {
  --indigo100: #ebf4ff;
  --indigo200: #c3dafe;
  --indigo300: #a3bffa;
  --indigo400: #7f9cf5;
  --indigo500: #667eea;
  --indigo600: #5a67d8;
  --indigo700: #4c51bf;
  --indigo800: #434190;
  --indigo900: #3c366b;
}
h1 {
  font-family: "Playfair Display";
  font-weight: 900;
  font-size: 6rem;
}
</style>
